// extracted by mini-css-extract-plugin
export default {"row":"eOsS99q12VGXc3f_H0gT","title":"XeKeCf9YihMu9hSKpgLw"};